import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DocumentService } from '../services/document.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentLibraryConstants } from '../document-library-constants';

@Component({
  selector: 'app-document-loader',
  templateUrl: './document-loader.component.html',
  styleUrls: ['./document-loader.component.scss']
})
export class DocumentLoaderComponent implements OnInit {
  isError : boolean = false;
  documentErrorMessage: string = DocumentLibraryConstants.DocumentViewer_Not_Found_Error;
  documentViewerInfoMessage: string = DocumentLibraryConstants.DocumentViewer_Downloading;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
  ) {

  }

  ngOnInit(): void {
    const documentId = this.route.snapshot.paramMap.get('id');
    if (documentId) {
      this.documentService.getFormattedFileURI(documentId).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe({
        next: (document) => {
          if (document?.fileUri) {
          window.location.assign(document.fileUri);
          this.documentViewerInfoMessage = DocumentLibraryConstants.Document_Ready_For_Download;
          this.isError = false;
          }
          else{
            this.isError = true;
            this.documentErrorMessage = DocumentLibraryConstants.DocumentViewer_Not_Found_Error;

          }
        },
        error: (err) => {
          this.isError = true;  
          if(err.status === 403){
            this.documentErrorMessage = err.error?.detail || DocumentLibraryConstants.DocumentViewerPermissionError;
          } else {
            this.documentErrorMessage = DocumentLibraryConstants.DocumentViewer_Not_Found_Error;
          }
        }
      });
    } else {
        this.isError = true;
    }
    
  }

}
